export const DISBURSEMENT_CONFIG_TAB_PERMISSIONS = {
  'fee-management': 'admin.config.disbursement.fee_management.view',
  'fee-ledger': 'admin.config.disbursement.fee_ledger.view',
  categories: 'admin.config.disbursement.categories.view',
} as const;

export function formatDisbursementCount(value: number): string {
  return new Intl.NumberFormat('en-NG').format(value);
}

export function formatNairaAmount(value: number): string {
  return `₦${formatDisbursementCount(value)}`;
}
